import React from "react";
import styled from "styled-components";

const Formulaire = styled.div`
    display: flex;
    flex-direction: column;
    .row {
        display: flex;
        justify-content: center;
        gap: 15px;
        margin: 5px 10px;
        align-items: center;
    }
    .row > label {
        text-align: left;
        width: 100px;
        padding-right: 10px;

        display: flex;
        justify-content: center;
    }
    .inputForm {
        padding: 5px;
        text-align: left;
    }

    select {
        padding: 3px;
    }

    .doubleRow > input {
        width: 530px;
    }
    .error {
        color: red;
        font-weight: bold;
        font-size: 1.4rem;
        padding: 8px;
    }
    .error {
        color: red;
        font-weight: bold;
        font-size: 1.4rem;
    }
`;
function FormEntreprise({ usage, dataEntreprise, handleChange, messageError }) {
    return (
        <Formulaire>
            
            <div className="row">
                <label htmlFor="antenne_enea">Antenne *</label>
                <select
                    name="antenne_enea"
                    id="antenne_enea"
                    value={dataEntreprise.antenne_enea}
                    onChange={handleChange}
                >
                    <option value="">--Choix--</option>
                    <option value="All">Toutes</option>
                    <option value="CI">Côte d'Ivoire</option>
                    <option value="To">Togo</option>
                    <option value="Be">Bénin</option>
                    <option value="BF">Burkina Faso</option>
                </select>

                {usage === "modalEntreprise" && (
                    <>
                        <label htmlFor="cat">Catégorie *</label>
                        <select
                            name="cat"
                            id="cat"
                            value={dataEntreprise.cat}
                            onChange={handleChange}
                        >
                            <option value="">--Choix--</option>
                            <option value="Prospect">Prospect</option>
                            <option value="Client">Client</option>
                            <option value="Fournisseur">Fournisseur</option>
                        </select>
                    </>
                )}
            </div>
            <div className="doubleRow row">
                <label htmlFor="nom">Nom *</label>
                <input
                    type="text"
                    name="nom"
                    id="nom"
                    value={dataEntreprise.nom}
                    onChange={handleChange}
                    className="inputForm"
                />
            </div>
            <div className="doubleRow row">
                <label htmlFor="adresse">Adresse</label>
                <input
                    type="text"
                    name="adresse"
                    id="adresse"
                    value={dataEntreprise.adresse ?? null}
                    onChange={handleChange}
                    className="inputForm"
                />
            </div>
            <div className="row">
                <label htmlFor="CP">CP</label>
                <input
                    type="text"
                    name="CP"
                    id="CP"
                    value={dataEntreprise.CP ?? null}
                    onChange={handleChange}
                    className="inputForm"
                />

                <label htmlFor="ville">Ville</label>
                <input
                    type="text"
                    name="ville"
                    id="ville"
                    value={dataEntreprise.ville ?? null}
                    onChange={handleChange}
                    className="inputForm"
                />
            </div>{" "}
                <div className="row">
                    <label htmlFor="siteInternet">Site Internet</label>
                    <input
                        type="text"
                        name="siteInternet"
                        id="siteInternet"
                        value={dataEntreprise.siteInternet ?? null}
                        onChange={handleChange}
                        className="inputForm"
                    />
                </div>
            {messageError !== "" && (
                <span className="error">{messageError}</span>
            )}
        </Formulaire>
    );
}

export default FormEntreprise;
